import React, { ReactNode, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { BigRadio } from './BigRadio';
import { Divider } from './Divider';
import { GAME_LINK_TYPE, GAME_TYPES_TYPE } from '../../constants/constants';
import { useJourneyQuery } from '../../graphql/journey/getJourney';
import { useSignedInContext } from '../../context/SignedInContext';
import { useFocusEffect } from '@react-navigation/native';
import getJourneyStages from '../../utils/journeysUtils';
import { useGetHivesQuery } from '../screens/MyHives/useGetHivesQuery.gql';

interface IGameTypeCardProps {
  title: string;
  onPress: () => void;
  disabled: boolean;
  gameType: GAME_TYPES_TYPE;
  operandIcon?: ReactNode;
  isLocked?: boolean;
  gameLinkType?: GAME_LINK_TYPE;
  hiveQuery?: boolean;
  route?: any;
}
const GameTypeCard = ({
  title,
  onPress,
  disabled,
  operandIcon,
  isLocked,
  gameType,
  gameLinkType,
  hiveQuery = false,
  route,
}: IGameTypeCardProps) => {
  const { user } = useSignedInContext();
  const userId = !hiveQuery ? user?.id : route?.params?.userId;

  const { error: getHivesError, data: getHivesData } = useGetHivesQuery();
  // const hiveId = hiveQuery ? route?.params?.hiveId : getHivesData?.hives?.[0]?.id ?? '';

  const { data, loading, refetch } = useJourneyQuery({
    variables: { userId: userId ?? '', gameType: gameType ?? '' },
    skip: !userId || !gameType || gameLinkType !== GAME_LINK_TYPE.JOURNEY ,
  });

  const { stages, totalStages } = getJourneyStages();

  // ✅ refetch when screen gains focus
  useFocusEffect(
    useCallback(() => {
      if (userId && gameType) {
        refetch();
      }
    }, [userId, gameType, refetch]),
  );

  const journeyData = data?.journeyByUserAndGametype ?? null;

  const index = stages.findIndex(stage => stage.id === journeyData?.currentStage);

  const journeyProgress =
    journeyData && index !== -1 ? Math.ceil((100 * index) / (totalStages - 1)) : 0;

  return (
    <>
      <View style={styles.container}>
        <BigRadio
          title={title}
          onPress={onPress}
          disabled={disabled}
          additionalIcon={operandIcon}
          isLocked={isLocked}
          gameType={gameType}
          progress={journeyProgress}
          hiveQuery={hiveQuery}
        />
      </View>
      <Divider empty height={12} />
    </>
  );
};

export { GameTypeCard };

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
